import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=4ad16d10&scoped=true&"
import script from "./checkbox-group.vue?vue&type=script&lang=js&"
export * from "./checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=4ad16d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad16d10",
  null
  
)

export default component.exports